export { default as PostTag } from './component';
